import fetch from 'isomorphic-fetch'
import { createAction } from 'redux-actions'
import URLSearchParams from 'url-search-params'
import Cookies from 'js-cookie'
import { upload, transcode } from '../api/video'
import { createFetchVideoRequest } from '../api/videos'
import { getUploads, getVideo, getSelectedVideos, isMobile, getAllVideos } from '../misc/selectors'
import * as Sentry from '@sentry/browser';
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import moment from 'moment'
import { setCookie, getBestSourceUrl } from '../misc/utilities'

export const FETCH_VIDEOS = 'FETCH_VIDEOS'
export const FETCH_UPLOADS = 'FETCH_UPLOADS'
export const FETCH_VIDEO = 'FETCH_VIDEO'

export const CLEAR_VIDEOS = 'CLEAR_VIDEOS'
export const CLEAR_VIDEO = 'CLEAR_VIDEO'

export const UPLOAD = 'UPLOAD'
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
export const RETRANSCODE = 'RETRANSCODE'

export const SHORTCODE_RECEIVED = 'SHORTCODE_RECEIVED'

export const SORT_CHANGED = 'SORT_CHANGED'
export const SEARCH_CHANGED = 'SEARCH_CHANGED'
export const RESET_FILTERS = 'RESET_FILTERS'

export const LOGIN = 'LOGIN'

export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER'

export const EDIT_USER = 'EDIT_USER'
export const EDIT_VIDEO = 'EDIT_VIDEO'

export const CREATE_VIDEO = 'CREATE_VIDEO'
export const DELETE_VIDEO = 'DELETE_VIDEO'

export const FETCH_STATS = 'FETCH_STATS'

export const DESELECT = 'DESELECT'
export const SELECT = 'SELECT'
export const DESELECT_ALL = 'DESELECT_ALL'

export const EXTRACT_URL = 'EXTRACT_URL'
export const CLEAR_CLIPPER = 'CLEAR_CLIPPER'
export const SET_THUMBNAIL_MODE = 'SET_THUMBNAIL_MODE'

export const ZOOM = 'ZOOM'

export const SET_STATS_DOMAIN = 'SET_STATS_DOMAIN'
export const SET_STATS_INTERVAL = 'SET_STATS_INTERVAL'

export const MESSAGE = 'MESSAGE'

export const SWITCH_VIDEOS_VIEW = 'SWITCH_VIDEOS_VIEW'

export const REMOVE_SUB_ACCOUNT = 'REMOVE_SUB_ACCOUNT'

export const ARTICLE_EXCLUDED = 'ARTICLE_EXCLUDED'

export const UPDATE_EMBED = 'UPDATE_EMBED'

export const SUBSCRIBE = 'SUBSCRIBE'
export const UPDATE_CARD = 'UPDATE_CARD'

export const NOTIFY = 'NOTIFY'

export const CREATE_TEMP_VIDEO = 'CREATE_TEMP_VIDEO'

function onLogin(user) {
  setTimeout(() => {
    var data = {
      version: process.env.REACT_APP_VERSION,
    }
    if (user.user_name) { 
      data.name = user.user_name + ' [' + user.plan_name + ']'  
      if (user.user_name.includes('@')) {
        data.email = user.user_name
      }
      data.payment_processor = user.payment_processor
      data.plan_name = user.plan
      data.subscription_status = user.subscription_status
      data.user_since = moment.unix(user.date_added).fromNow()    
    }


    window.Beacon('identify', data)
  }, 0)
}

export function log(message) {
  return (dispatch, getState) => {
    const { me } = getState()
    console.log(message)
    return fetch(`${process.env.REACT_APP_API_HOST}/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        message,
        version: me.version,
      }),
      credentials: 'include',
    })
  }
}

export function fetchExtraUserInfo(type) {
  return (dispatch) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/me/${type}`, {
      credentials: 'include',
    }).then(async function(response) {
      if (!response.ok) {
        throw Error(await response.text())
      }
      return response.json();
    })
    .then((json) => {
      dispatch(createAction(FETCH_CURRENT_USER)(json))
      return json
    })
    .catch(e => {
   
    })
  }
}
export function fetchCurrentUser() {
  return (dispatch) => {
    dispatch(createAction(FETCH_CURRENT_USER)({ isFetching: true }))
    return fetch(`${process.env.REACT_APP_API_HOST}/me`, {
      credentials: 'include',
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(createAction(FETCH_CURRENT_USER)({ isFetching: false, ...json }))
      if (json.user_name) {
        onLogin(json)
      }

      if (WebSocket) {
        const ws = new WebSocket(json.socket)
        ws.onmessage = (e) => {
          const parsedMessage = JSON.parse(e.data)
          if (parsedMessage.type === 'ping') {
            ws.send(JSON.stringify({ type: 'pong' }))
            return
          }
          dispatch(createAction(MESSAGE)(parsedMessage))
        }
        dispatch(createAction(EDIT_USER)({ws}))
      }
      return json
    })
    .catch(error => {
      Sentry.captureException(error);
      dispatch(createAction(FETCH_CURRENT_USER)(error))
    })
  }
}

export function userSubscribePlan(paymentMethodId, plan, subscriptionId, token, src_internal, notrial) {
  return (dispatch) => { 
    let url = `${process.env.REACT_APP_API_HOST}/me/subscribe/${plan}`
    dispatch(createAction(SUBSCRIBE)({ purchasing: true }))
    const body = {
      token,
      src_internal
    }
    if (notrial) {
      body.notrial = true
    }
    if (paymentMethodId) {
      body.payment_method = paymentMethodId
    } else if (subscriptionId) {
      body.subscription_id = subscriptionId
    } else {
      throw new Error("No payment method specified.")
    }

    return fetch(url, {
      credentials: 'include',
      headers: {
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body),
    }).then(async function(response) {
      if (!response.ok) {
        if (response.status == 429) {
          throw Error("Too many attempts. Please try again later.")
        } else {
          throw Error(await response.text())
        }
      }
      return response.json();
    }).then(async function(json) {
      await dispatch(createAction(FETCH_CURRENT_USER)(json))
      dispatch(createAction(SUBSCRIBE)({ purchasing: false }))
      return json
    })
    .catch(error => {
      Sentry.captureException(error);
      dispatch(createAction(SUBSCRIBE)(error))
      throw error
    })
  }
}

export function userChangePayment(paymentMethodId, token) {
  return (dispatch) => {
    let url = `${process.env.REACT_APP_API_HOST}/me/change_payment`
    dispatch(createAction(UPDATE_CARD)({ purchasing: true }))
    return fetch(url, {
      credentials: 'include',
      headers: {
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        payment_method: paymentMethodId,
        token
      }),
    }).then(async function(response) {
      if (!response.ok) {
        if (response.status == 429) {
          throw Error("Too many attempts. Please try again later.")
        } else {
          throw Error(await response.text())
        }
      }
      return response.json();
    }).then(async function(json) {
      await dispatch(createAction(FETCH_CURRENT_USER)(json))
      dispatch(createAction(UPDATE_CARD)({ purchasing: false }))
      return json
    })
    .catch(error => {
      Sentry.captureException(error);
      dispatch(createAction(UPDATE_CARD)(error))
      throw error
    })
  }
}
export function fetchVideo(shortcode, version) {
  return (dispatch, getState) => {
    if (getState().video && getState().video.shortcode !== shortcode) {
      dispatch(createAction(CLEAR_VIDEO)())
    }
    dispatch(createAction(FETCH_VIDEO)({ isFetching: true, shortcode }))
    let url = `${process.env.REACT_APP_API_HOST}/videos/${shortcode}`
    if (version) {
      url += `?version=${version}`
    }
    return fetch(url, {
      credentials: 'include',
      headers: {
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
    }).then(async function(response) {
      if (!response.ok) {
        throw Error(await response.text())
      }
      return response.json();
    }).then((json) => {
      dispatch(createAction(FETCH_VIDEO)({ isFetching: false, ...json }))
      return json
    })
    .catch(error => {
      Sentry.captureException(error);
      dispatch(createAction(FETCH_VIDEO)(error))
    })
  }
}

function editVideoInternal(shortcode, data, dispatch, purge, shouldUpdate) {
  return fetch(`${process.env.REACT_APP_API_HOST}/videos/${shortcode}?purge=${purge || ''}`, {
    credentials: 'include',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',
    },
    body: JSON.stringify(data),
  })
  .then(async (response) => {
    if (!response.ok) {
      throw Error(await response.text())
    }
    return response.json()
  })
  .then(json => {
    let edits = { isSaving: false, shortcode }
    if (shouldUpdate) {
      edits = { ...json, ...edits }
    }
    dispatch(createAction(EDIT_VIDEO)(edits))
  })
  .catch(error => {
    Sentry.captureException(error);
    dispatch(createAction(EDIT_VIDEO)(error))
  })
}
const editVideoDebounced = debounce(editVideoInternal, 1000)
const editVideoThrottled = throttle(editVideoInternal, 10000, {leading: false})

export function editVideo(shortcode, data, debounced=false, throttled=false, purge=false, shouldUpdate=false) {
  return (dispatch, getState) => {
    dispatch(createAction(EDIT_VIDEO)({ isSaving: true, shortcode, ...data }))

    if (debounced) {
      editVideoDebounced(shortcode, data, dispatch, purge, shouldUpdate)
    } else if (throttled) {
      editVideoThrottled(shortcode, data, dispatch, purge, shouldUpdate)
    } else {
      return editVideoInternal(shortcode, data, dispatch, purge, shouldUpdate)
    }
  }
}

export function cancelVideoEdits(shortcode) {
  return (dispatch, getState) => fetch(`${process.env.REACT_APP_API_HOST}/videos/${shortcode}/cancel_edits`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',
    },
    credentials: 'include',
  })
  .then(response => response.json())
  .then((video) => {
    dispatch(createAction(EDIT_VIDEO)(video))
    return video
  })
}

export function errorVideo(shortcode, message) {
  return (dispatch) => {
    dispatch(editVideo(shortcode, {
      status: 3,
      error: message,
    }))
  }
}

export function uploadSpeedTest() {
  return (dispatch, getState) => {
    const { me } = getState()
    const formData = new FormData()
    for (const fieldName of Object.keys(me.speedtest_fields)) {
      formData.append(fieldName, me.speedtest_fields[fieldName])
    }
    let content = ""
    for (let i = 0; i < 50000; i++) {
      content += Math.random().toString(36).substring(10)
    }

    formData.append('file', new Blob([content]))
    let start = Date.now()
    return fetch(me.speedtest_url, {
      method: 'POST',
      body: formData
    })
    .then(async response => await response.text())
    .then((text) => {
      let delta = Date.now() - start
      dispatch(createAction(EDIT_USER)({uploadSpeed: delta}))
      return delta
    })
  }
}

export function createVideoFromFile(file, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const { me } = state
    let fileName
    if (!isMobile(state)) {
      const n = file.name.lastIndexOf(".")
      fileName = n > -1 ? file.name.substr(0, n) : file.name
    }
    if (me.plan_max_size) {
      if (file.size > me.plan_max_size * 1073741824) {
        let maxSizeStr = `${me.plan_max_size.toString()}GB`
        if (me.plan_max_size < 1) {
          maxSizeStr = `${(me.plan_max_size * 1000).toString()}MB`
        }
        const message = `This video exceeds the max file size for your plan (${maxSizeStr})`
        dispatch(createAction(EDIT_USER)({ videoExceedsLimits: 'video-toolarge' }))
        dispatch(log("File upload too large: " + fileName + " (" + file.type + ", " + file.size + " bytes)"))
        throw new Error(message)
      }
    }

    const local_id = Math.random().toString(36).replace(/[^a-z]+/g, '')
    // Watch out, these might be overriden later by the editVideo
    dispatch(createAction(CREATE_VIDEO)({
      local_id,
      title: options.title || fileName,
    }))
    if (!file.size) {
      dispatch(errorVideo(local_id, 'Invalid file size (Try Safari if on iOS)'))
      throw new Error('Invalid file size (Try Safari if on iOS)')
    }

    
    let url = `${process.env.REACT_APP_API_HOST}/shortcode?size=${file.size}&version=${me.version}`
    if (me.uploadSpeed) {
      url += `&speed=${me.uploadSpeed}`
    }
    return fetch(url, {
      credentials: 'include',
      headers: {
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
    })
    .then(async (response) => {
      if (!response.ok) {
        const message = await response.text()
        throw Error(message + " (" + response.status + ")")
      }
      return response.json()
    })
    .then((metadata) => {
      if (!metadata.shortcode) {
        throw Error("No shortcode present in metadata")
      }
      const shortcode = metadata.shortcode
      const upload_size = file.size
      metadata.local_id = local_id
      dispatch(createAction(SHORTCODE_RECEIVED)(metadata))
      dispatch(editVideo(shortcode, {
        original_size: upload_size,
        original_name: file.name,
        upload_source: options.upload_source,
        title: options.title || fileName,
      }))

      let recentSpeeds = []
      let lastTime = null
      const startTime = Date.now()
      const task = upload(
        file, 
        { ...metadata.options, ...options }, 
        metadata, 
        (err, data) => {
          if (err) {
            dispatch(errorVideo(shortcode, err.message))
            return
          }

          const upload_time = Date.now() - startTime
          dispatch(createAction(UPLOAD)({
            shortcode,
            upload_metadata: metadata,
            transcode_options: options,
            transcode_data: data,
            upload_time,
            upload_percent: 100,
            percent: 0,
            waitingToTranscode: true,
          }))
        }, (data) => {
          if (data.speed != null) {
            recentSpeeds.unshift(data.speed > 0 ? data.speed : 0)
          }
          recentSpeeds = recentSpeeds.slice(0, 100)
          let sum = recentSpeeds.reduce(function(a, b){
            return a + b;
          }, 0);
          let avg = sum / recentSpeeds.length
          dispatch(createAction(UPLOAD_PROGRESS)({
            shortcode,
            upload_percent: data.percent,
            upload_speed: avg,
            retries: data.retries
          }))
          dispatch(editVideo(shortcode, {upload_percent: Math.round(data.percent)}, false, true))
        }, () => {
          dispatch(createAction(EDIT_VIDEO)({
            shortcode,
            waitingToUpload: false,
          }))
        }, message => {
          if (!message.includes('0 retries] uploadPart(')) {
            dispatch(log(message))
          }
        })

      dispatch(createAction(EDIT_VIDEO)({
        shortcode,
        waitingToUpload: task.queued,
        task,
      })
    )

      return metadata
    })
    .catch((err) => {
      Sentry.captureException(err);
      dispatch(errorVideo(local_id, err.message))
    })
  }
}

export function createVideoFromFiles(files, options) {
  return (dispatch) => {
    const promises = []
    for (let i = 0; i < files.length; i += 1) {
      const file = files[i]
      promises.push(dispatch(createVideoFromFile(file, options)))
    }
    return Promise.all(promises)
  }
}

export function createVideo(data) {
  return (dispatch, getState) => fetch(`${process.env.REACT_APP_API_HOST}/videos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',
    },
    body: JSON.stringify(data),
    credentials: 'include',
  })
  .then(response => response.json())
  .then((video) => {
    dispatch(createAction(CREATE_VIDEO)(video))
    return video
  })
}

export function createVideoWithOptions(options, data = {}) {
  return (dispatch, getState) => dispatch(createVideo({
    ...data,
    upload_source: options.upload_source,
    title: options.title,
    status: 1,
  }))
  .then((video) => {
    const { shortcode, token } = video
    options.shortcode = shortcode
    options.token = token
    return new Promise(
      (resolve, reject) => {
        transcode(options, (err) => {
          if (err) {
            dispatch(errorVideo(shortcode, err.message))
            reject(err)
            return
          }
          dispatch(createAction(UPLOAD)(data))
          resolve(video)
        })
      }
    )
  })
}


export function createVideoFromUrl(url, options = {}, data = {}) {
  return (dispatch, getState) => {
    options.url = url

    return dispatch(createVideoWithOptions(options, data))
  }
}

export function createVideoFromUrls(urls, options = {}, data = {}) {
  return (dispatch, getState) => {
    options.urls = urls

    return dispatch(createVideoWithOptions(options, data))
  }
}

export function pollVideo(shortcode, targetVersion) {
  return (dispatch, getState) => {
    return new Promise(
      (resolve, reject) => {
        const video = getVideo(getState().videos.cache, shortcode)
        if (targetVersion && video.version === targetVersion) {
          resolve()
        } else {
          dispatch(fetchVideo(shortcode, targetVersion))
          .then(() => {
            setTimeout(() => {
              const shortcode = getState().video.shortcode
              if (!shortcode) {
                reject();
                return;
              }
              dispatch(pollVideo(shortcode, targetVersion))
              .then(resolve)
              .catch(reject)
            }, 500)
          })
          .catch(reject)
        }
      }
    )
  }
}

export function screenshot(shortcode, options = {}) {
  return (dispatch) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/screenshot/${shortcode}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(options),
      credentials: 'include',
    })
    .then(async (response) => {
      if (!response.ok) {
        throw Error(await response.text())
      }
      const result = await response.json()
      dispatch(createAction(EDIT_VIDEO)({ ...result, shortcode }))
      return result
    })
  }
}

export function uploadScreenshot(shortcode, screenshot) {
  return (dispatch) => {
    const formData = new FormData()
    formData.append('screenshot', screenshot)
    return fetch(`${process.env.REACT_APP_API_HOST}/screenshot/${shortcode}/upload`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    })
    .then(async (response) => {
      if (!response.ok) {
        throw Error(await response.text())
      }
      const result = await response.json()
      dispatch(createAction(EDIT_VIDEO)({ ...result, shortcode }))
      return result
    })
  }
}

export function retranscodeVideo(video, options = {}) {
  return (dispatch) => {
    options.version = (video.max_version || video.version || 0) + 1
    options.url = `https:${getBestSourceUrl(video)}`
    options.shortcode = video.shortcode
    const output = {
      ...video, status: 1, percent: 0, max_version: options.version,
    }
    dispatch(createAction(RETRANSCODE)(output))
    return new Promise(
      (resolve, reject) => {
        transcode(options, (err, data) => {
          if (err) {
            dispatch(createAction(RETRANSCODE)(err))
            reject(err)
            return
          }
          resolve(output)
        })
      }
    )
  }
}

// Only let the current stats fetch come through, otherwise null it out
function checkStatsResult(state, options, json) {
  const { interval, domain, shortcode } = state
  /*if (options.interval !== interval
      || options.domain !== domain
      || options.shortcode !== shortcode) {
    return {}
  }*/
  return json
}

export function fetchRealtimeStats(options = {}) {
  return (dispatch, getState) => {
    const { domain, shortcode } = options
    if (shortcode) {
      fetch(`${process.env.REACT_APP_API_HOST}/${shortcode}/stats/live`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => {
          dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { live: json })))
        })
        .catch(error => {
          dispatch(createAction(FETCH_STATS)(error))
        })
    } else if (domain) {
      fetch(`${process.env.REACT_APP_API_HOST}/domain/${domain}/stats/hot`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { hot: json }))))
        .catch((error) => dispatch(createAction(FETCH_STATS)({ hot: null })))
      fetch(`${process.env.REACT_APP_API_HOST}/domain/${domain}/stats/live`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { live: json }))))
        .catch(error => dispatch(createAction(FETCH_STATS)({ live: null })))
    } else {
      fetch(`${process.env.REACT_APP_API_HOST}/stats/hot`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { hot: json }))))
        .catch(error => dispatch(createAction(FETCH_STATS)({ hot: null })))
      fetch(`${process.env.REACT_APP_API_HOST}/stats/live`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { live: json }))))
        .catch(error => dispatch(createAction(FETCH_STATS)({ live: null })))
    }
  }
}

export function fetchStats({ interval, domain, shortcode, trending } = {}) {
  return (dispatch, getState) => {
    const options = {
      interval,
      domain,
      shortcode,
      trending,
    }
    dispatch(createAction(FETCH_STATS)({
      ...options,
    }))

    if (shortcode) {
      fetch(`${process.env.REACT_APP_API_HOST}/${shortcode}/plays`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => {
          dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { plays: json })))
        })
        .catch(error => {
          dispatch(createAction(FETCH_STATS)(error))
        })
      fetch(`${process.env.REACT_APP_API_HOST}/${shortcode}/articles`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { articles: json }))))
        .catch(error => dispatch(createAction(FETCH_STATS)(error)))
    } else if (domain) {
      fetch(`${process.env.REACT_APP_API_HOST}/domain/${domain}/stats?interval=${interval}`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, json))))
        .catch(error => dispatch(createAction(FETCH_STATS)(error)))
    } else if (trending) {
      fetch(`${process.env.REACT_APP_API_HOST}/trending/${trending}/articles`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { articles: json }))))
        .catch(error => dispatch(createAction(FETCH_STATS)(error)))
    } else {
      const urlRoot = `${process.env.REACT_APP_API_HOST}/stats/`
      fetch(`${urlRoot}plays`, { credentials: 'include' })
        .then(response => response.json())
        .then(json => dispatch(createAction(FETCH_STATS)(checkStatsResult(getState().stats, options, { plays: json }))))
        .catch(error => dispatch(createAction(FETCH_STATS)({ plays: null })))
    }

    dispatch(fetchRealtimeStats({ interval, domain, shortcode }))
  }
}

export function excludeArticle(domain, article, shortcode) {
  return (dispatch, getState) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/domain/${domain}/exclude`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        article,
        shortcode,
      }),
    })
    .then(response => response.json())
    .then(json => dispatch(createAction(ARTICLE_EXCLUDED)(json)))
  }
}

export function fetchVideos(options, force) {
  return (dispatch, getState) => {
    const { videos } = getState()

    // shallow compare options and video state to see if we're getting new
    let shouldClear = !!force
    for (const key of Object.keys(options)) {
      if (videos[key] !== options[key]) {
        shouldClear = true
      }
    }

    if (shouldClear) {
      dispatch(createAction(CLEAR_VIDEOS)())
    }

    if (shouldClear || !videos.loaded) {
      dispatch(createAction(FETCH_VIDEOS)({ isFetching: true, ...options }))
      return createFetchVideoRequest(options)
      .then(json => dispatch(createAction(FETCH_VIDEOS)({ isFetching: false, ...json })))
      .catch(error => {
        Sentry.captureException(error);
        dispatch(createAction(FETCH_VIDEOS)(error))
      })
    }
  }
}

export function login(email, password) {
  return (dispatch) => {
    dispatch(createAction(LOGIN)({ loggingIn: true }))
    return fetch(`${process.env.REACT_APP_API_HOST}/check`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        username: email,
        password,
      }),
    })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(await response.text())
      }
      const json = await response.json()
      if (json.error) {
        throw new Error(json.message)
      }
      await dispatch(createAction(FETCH_CURRENT_USER)(json))
      await dispatch(createAction(LOGIN)({ loggingIn: false, error: false, message: null, ...json }))
      onLogin(json)
      return json
    })
    .catch(error => {
      Sentry.captureException(error);
      dispatch(createAction(LOGIN)(error))
    })
  }
}

export function extConnect(authToken, email, provider) {
  return (dispatch) => {
    let error = false
    dispatch(createAction(LOGIN)({ loggingIn: true }))
    return fetch(`${process.env.REACT_APP_API_HOST}/extconnect`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        authToken,
        email,
        provider,
      }),
    })
    .then(response => response.json())
    .then(async (json) => {
      if (json.error) {
        throw new Error(json.message)
      }
      await dispatch(createAction(LOGIN)({ loggingIn: false, ...json }))
      onLogin(json)
      return json
    })
    .catch(err => {
      Sentry.captureException(err);
      dispatch(createAction(LOGIN)(err))
    })
  }
}

export function signup(username, password, email, verificationRedirect) {
  return (dispatch) => {
    let error = false
    dispatch(createAction(LOGIN)({ loggingIn: true }))
    return fetch(`${process.env.REACT_APP_API_HOST}/users`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        username,
        password,
        email,
        verification_redirect: verificationRedirect
      }),
    })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(await response.text())
      }
      const user = await response.json()
      await dispatch(createAction(LOGIN)({ loggingIn: false, ...user }))
      onLogin(user)
      return user
    })
    .catch(err => {
      Sentry.captureException(err);
      dispatch(createAction(LOGIN)(err))
    })
  }
}

export function resendVerificationEmail() {
  return (dispatch, getState) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/verify`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      }
    })
  }
}

export function checkTranscodes() {
  return (dispatch, getState) => {
    const uploads = getUploads(getState()).filter(v => v.status == 1)
    const waiting = getAllVideos(getState()).filter(v => v.waitingToTranscode)

    waiting.forEach(v => {
      const { shortcode, waitingToTranscode, transcode_options, upload_metadata } = v
      if (uploads.length > 2) {
        dispatch(createAction(EDIT_VIDEO)({ queued: true, shortcode }))
      } else {
        dispatch(createAction(EDIT_VIDEO)({ waitingToTranscode: false, shortcode,}))

        const transcoderOptions = {
          ...transcode_options,
          ...upload_metadata.transcoder_options,
        }
        transcode(transcoderOptions, (err, data) => {
          if (err) {
            dispatch(errorVideo(shortcode, err.message))
            return
          }
          dispatch(createAction(EDIT_VIDEO)({ status: 1, shortcode,}))
        })
      }
    })
  }
}

export function pollUploads() {
  return (dispatch, getState) => {
    const uploads = getAllVideos(getState()).filter(v => v.status == 1)
    if (uploads.length) {
      const timeout = setTimeout(() => {
        dispatch(createAction(EDIT_USER)({'networkerror': true}))
      }, 5000);
      fetch(`${process.env.REACT_APP_API_HOST}/poll2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
        },
        body: JSON.stringify(uploads.map(v => { return { shortcode: v.shortcode, version: v.max_version }})),
        credentials: 'include',
      })
      .then(response => response.json())
      .then((json) => {
        dispatch(createAction(FETCH_UPLOADS)(json))
        dispatch(createAction(EDIT_USER)({'networkerror': false}))
        clearTimeout(timeout);
      })
      .catch((error) => {
        dispatch(createAction(EDIT_USER)({'networkerror': true}))
        clearTimeout(timeout);
      })
    }
  }
}

export function editUser(data) {
  return (dispatch, getState) => {
    dispatch(createAction(EDIT_USER)(data))

    if ('dark_mode' in data) {
      setCookie('dark_mode', data.dark_mode, 90000)
      document.documentElement.style.backgroundColor = data.dark_mode ? "#151515" : ""
    }
    return fetch(`${process.env.REACT_APP_API_HOST}/me`, {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        session: Cookies.get('session'),
        ...data,
      }),
    })
    .then(async (response) => {
      if (!response.ok) {
        throw Error(await response.text())
      }
      return response.json()
    })
    .then((json) => {
      dispatch(createAction(EDIT_USER)(json))
    })
    .catch((error) => {
      Sentry.captureException(error);
      alert(error.message)
    })
  }
}

export function uploadPic(photo) {
  return (dispatch, getState) => {
    const formData = new FormData()
    formData.append('watermark', photo)

    return fetch(`${process.env.REACT_APP_API_HOST}/me/pic`, {
      credentials: 'include',
      method: 'POST',
      body: formData,
    })
    .then(response => response.json())
    .then(json => dispatch(createAction(EDIT_USER)(json)))
  }
}


export function changePassword(data) {
  return (dispatch, getState) => {
    dispatch(createAction(EDIT_USER)({isFetching: true}))
    return fetch(`${process.env.REACT_APP_API_HOST}/me/change_password`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({
        session: Cookies.get('session'),
        ...data,
      }),
    })
    .then(async response => {
      if (!response.ok) {
        throw Error(await response.text())
      }
      return response.json()
    })
    .then((json) => {
      if (json.error) {
        throw new Error(json.message)
      }
      json.isFetching = false;
      return dispatch(createAction(EDIT_USER)(json))
    })
    .catch(error => {
      Sentry.captureException(error);
      dispatch(createAction(EDIT_USER)(error))
    })
  }
}

export function deleteVideo(video) {
  return (dispatch) => {
    if (video.shortcode) {
      dispatch(createAction(DELETE_VIDEO)({ isDeleting: true, ...video }))
      return fetch(`${process.env.REACT_APP_API_HOST}/videos/${video.shortcode}`, {
        credentials: 'include',
        method: 'DELETE',
      })
        .then(async response => await response.text())
        .then(() => {
          dispatch(createAction(DELETE_VIDEO)({ ...video, isDeleting: false }))
        })
        .catch(error => dispatch(createAction(DELETE_VIDEO)(error)))
    }
    dispatch(createAction(DELETE_VIDEO)({ isDeleting: false, ...video }))
  }
}

export function deleteSelectedVideos() {
  return (dispatch, getState) => {
    const promises = []
    for (const video of getSelectedVideos(getState())) {
      promises.push(dispatch(deleteVideo(video)))
    }
    return Promise.all(promises)
  }
}

export function extractFromUrl(sourceUrl, groupId, retries=0) {
  return (dispatch, getState) => {
    dispatch(createAction(EXTRACT_URL)({ isFetching: true }))

    const searchParams = new URLSearchParams()
    searchParams.append('url', sourceUrl)
    return fetch(`${process.env.REACT_APP_API_HOST}/extract?${searchParams}`, { credentials: 'include' })
      .then(response => response.json())
      .then((json) => {
        dispatch(createAction(EXTRACT_URL)({ isFetching: false, retries, ...json }))
      })
      .catch(error => {
        Sentry.captureException(error);
        dispatch(createAction(EXTRACT_URL)(error))
      })
  }
}

export function loadFile(file, groupId) {
  return (dispatch, getState) => {
    dispatch(createAction(EXTRACT_URL)({ 
      playback_url: window.URL.createObjectURL(file),
      mime: file.type,
      file,
    }))
  }
}

export function cancel(video) {
  return (dispatch, getState) => {
    if (!video.max_version) {
      dispatch(editVideo(video.shortcode, {status: 4}))
      dispatch(createAction(DELETE_VIDEO)(video))
      if (video.task) {
        video.task.cancel()
      }
    } else {
      dispatch(cancelVideoEdits(video.shortcode))
    }
  }
}

export function clearStats() {
  return (dispatch, getState) => {
    dispatch(createAction(FETCH_STATS)({
      plays: null,
      hot: null,
      pages: null,
      videos: null,
      live: null,
      vtrs: null,
    }))
  }
}

export function forgotPassword(email) {
  const formData = new FormData()
  formData.append('email', email)
  return (dispatch, getState) => fetch(`${process.env.REACT_APP_API_HOST}/users/reset`, {
    credentials: 'include',
    method: 'POST',
    body: formData,
  })
  .then(response => response.ok)
}

export function changePlan(plan, reason, reason_category) {
  return (dispatch, getState) => {
    dispatch(createAction(EDIT_USER)({loading_plan: true}))
    return fetch(`${process.env.REACT_APP_API_HOST}/me/plan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({plan, reason, reason_category}),
      credentials: 'include',
    }).then(async response => {
      if (!response.ok) {
        throw Error(await response.text())
      }
      response.json().then(data => {
        dispatch(createAction(EDIT_USER)({ ...data, loading_plan: false}))
      });
    })
  }
}
